import styled from 'styled-components';
import { Container as DesktopFiltersContainer } from '@/components/Filters/DesktopFilters/DesktopFilters.styles';

export const Section = styled.section`
  width: 100%;
  padding: 40px 40px 60px;
  margin-top: 20px;
  border-radius: 40px 40px 0 0;
  background: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
    margin-top: 10px;
    border-radius: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 30px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 12px;
  }
`;

export const Title = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 17px;
    line-height: 20px;
  }
`;

export const DesktopSorting = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

/** Horizontally-scrollable mobile filter chip row. */
export const MobileFiltersRow = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    margin-bottom: 25px;
  }
`;

export const Body = styled.div`
  display: flex;
  gap: 15px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
  }
`;

export const Sidebar = styled.aside`
  flex: 0 0 240px;

  & > ${DesktopFiltersContainer} {
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const ListColumn = styled.div`
  flex: 1 1 0;
  min-width: 0;
`;

export const Count = styled.div`
  color: ${({ theme }) => theme.palette.quartenary.labels};
  font-size: 16px;
  line-height: 22px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 14px;
    line-height: 18px;
  }
`;

/** Count (left) + mobile sorting label (right), above the ads grid. */
export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 16px;
  }
`;

export const MobileSorting = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
  }
`;
